import React from 'react';
import PropTypes from 'prop-types';

const Abbr = ({ title, children, breakpoint = 'fromNarrow' }) => (
    <abbr
        className={`pp-abbr pp-abbr__${breakpoint}`}
        title={title}
    >
        <span className="pp-abbr__inner">
            {children || title.charAt(0)}
        </span>
    </abbr>
);

Abbr.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    breakpoint: PropTypes.string,
};

export default Abbr;



// WEBPACK FOOTER //
// ./src/js/shared/Abbr.jsx